import { CardSvg } from '@/play/cardSvg'

/** Home card art: a sheet of paper on a table with fat, shiny finger-paint strokes and blobs. */
export function FingerPaintingCardArt() {
  return (
    <CardSvg bg="#c8b89e">
      <path d="M44 40 H276 L284 176 H36 Z" fill="#7d6a52" opacity="0.25" transform="translate(3 4)" />
      <path d="M44 40 H276 L284 176 H36 Z" fill="#f6f4ee" />
      {/* a yellow sun blob, a blue sky swirl, a green hill and a red heart-ish dab */}
      <circle cx="96" cy="82" r="22" fill="#ffd60a" />
      <circle cx="90" cy="75" r="7" fill="#ffffff" opacity="0.6" />
      <path d="M150 74 C 170 52, 210 52, 236 74" stroke="#2468e0" strokeWidth="16" fill="none" strokeLinecap="round" />
      <path d="M150 70 C 170 50, 200 50, 220 62" stroke="#ffffff" strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.55" />
      <path d="M58 156 C 100 118, 160 120, 190 146 C 220 126, 250 130, 268 156" stroke="#34b233" strokeWidth="18" fill="none" strokeLinecap="round" />
      <circle cx="200" cy="112" r="13" fill="#e8231e" />
      <circle cx="224" cy="118" r="10" fill="#ff6fae" />
      <circle cx="196" cy="107" r="4" fill="#ffffff" opacity="0.6" />
    </CardSvg>
  )
}
